export class ShopifyClient {
    private storeUrl: string = '';

    constructor({ storeUrl }: { storeUrl: string }) {
        if (!storeUrl) {
            console.log(
                'Domain (Store Admin domain), version (API), and token (Shopify-Access-Token) are required.'
            );
        }

        this.storeUrl = storeUrl;
    }

    private extractShopifyId = (gid: string | number): string => {
        if (typeof gid === 'number') return gid.toString();

        // If it's already a numeric string, return it
        if (typeof gid === 'string' && /^\d+$/.test(gid)) {
            return gid;
        }

        // Extract ID from GraphQL format
        if (typeof gid === 'string' && gid.includes('gid://shopify/')) {
            const parts = gid.split('/');
            return parts[parts.length - 1];
        }

        // Return as is if we can't parse it
        return gid.toString();
    };

    public updateCartCount = async () => {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) {
                throw new Error(
                    `Network response was not ok: ${response.status}`
                );
            }

            const cart = await response.json();

            console.log(cart, 'Updated cart InC');

            if (cart && typeof cart.item_count !== 'undefined') {
                const cartCountElements =
                    document.querySelectorAll('.cartCount');
                cartCountElements.forEach((element) => {
                    element.innerHTML = cart.item_count.toString();
                });
            }
        } catch (error) {
            console.error('Error updating cart count:', error);
        }
    };

    // remove_item_from_cart
    // This method removes an item from the cart by its variant ID and quantity.
    // It constructs a FormData object with the variant ID and quantity,
    // sends a POST request to the Shopify cart change endpoint,
    // and updates the cart count after a successful response.

    public remove_item_from_cart = async ({
        variant_id,
        quantity = 0 // default to 0 if not provided
    }: Record<string, any>) => {
        console.log(variant_id, 'variantId');

        try {
            const variantId = this.extractShopifyId(variant_id);

            const fd = new FormData();
            fd.append('id', variantId);
            fd.append('quantity', quantity.toString());

            const res = await fetch(`${this.storeUrl}/cart/change.js`, {
                method: 'POST',
                body: fd,
                headers: {
                    Accept: 'application/json'
                }
            });

            console.log('[CART_SERVICE] Response status:', res);

            if (!res.ok) {
                const errorText = await res.text();
                console.error(
                    '[CART_SERVICE] Cart API error response:',
                    errorText
                );
                throw new Error(
                    `Failed to add to cart: ${res.status} - ${errorText}`
                );
            }

            const data = await res.json();
            await this.updateCartCount();
            return data;
        } catch (error) {
            console.log(error);
        }
    };

    public view_cart_summary = async () => {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) {
                throw new Error(
                    `Network response was not ok: ${response.status}`
                );
            }

            const cart = await response.json();
            return {
                type: 'view_cart_summary',
                data: cart
            };
        } catch (error) {
            console.error('Error updating cart count:', error);
            return null;
        }
    };

    // apply_discount
    // This method applies a discount code to the cart.
    // It sends a GET request to the /discount/{discountCode} endpoint,
    // checks if the response is OK, and logs the response.
    // If the request fails, it logs an error message to the console.
    // Note: The response type is not JSON, so we do not parse it.
    // Instead, we just log the response object.
    // This is useful for debugging purposes.

    //they are secret codes and there are 4 types of discount in shopify
    // free shipping
    // BOGO
    //product base
    //etc
    public apply_discount = async (discountCode?: Record<string, any>) => {
        try {
            const response = await fetch(
                `${this.storeUrl}/discount/${discountCode}`
            );

            console.log('[CART_SERVICE] Discount response:', response);

            if (!response.ok) {
                const errorText = await response.text();
                console.error(
                    '[CART_SERVICE] Discount API error response:',
                    errorText
                );
                throw new Error(
                    `Failed to apply discount: ${response.status} - ${errorText}`
                );
            }

            // we need to check response type its not json
            console.log(response, 'response');
        } catch (error) {
            console.error('Error applying discount:', error);
        }
    };

    public add_to_cart = async ({
        variant_id,
        quantity
    }: Record<string, any>) => {
        console.log(variant_id, 'variantIdvariantId');

        try {
            const variantId = this.extractShopifyId(variant_id);

            const fd = new FormData();
            fd.append('id', variantId);
            fd.append('quantity', quantity.toString());

            const res = await fetch(`${this.storeUrl}/cart/add.js`, {
                method: 'POST',
                body: fd,
                headers: {
                    Accept: 'application/json'
                }
            });

            console.log('[CART_SERVICE] Response status:', res);

            if (!res.ok) {
                const errorText = await res.text();
                console.error(
                    '[CART_SERVICE] Cart API error response:',
                    errorText
                );
                throw new Error(
                    `Failed to add to cart: ${res.status} - ${errorText}`
                );
            }

            const data = await res.json();

            await this.updateCartCount();
            return data;
        } catch (error) {
            console.log(error);
        }
    };
}
